import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";

const DecayStockFollowUpsView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});

  const [followups, setFollowups] = useState([]);

  useEffect(() => {
    

    axios
      .get(`/helpers/decay-stock-follow-ups/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.followups_sum);
          setFollowups(response.data.data.followups);
          console.log(response.data.data.followups);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Decay Stock Follow Ups</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-stock-follow-ups">Decay Stock Follow Ups</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Raw Material
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Decay Stock Follow Ups</h4>
                    <table className="table table-bordered">
                     
                      <tr>
                        <th className="p-3">Product Name</th>
                        <td className="p-3">
                          {value.product_name ? value.product_name.name : ""}
                        </td>
                      </tr>
                        <tr>
                        <th className="p-3">Total Decay Net Weight</th>
                        <td className="p-3">
                          {value.total_decay_net_weight} KG
                        </td>
                      </tr>
                      
                     

                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Decay Stock Follow Ups Details</h5>

                    <table className="table table-bordered">
                          <thead>
                          <tr>
                            <th className="p-3">Decay Net Weight</th>
                          </tr>
                          </thead>
                          <tbody>
                          {followups &&  followups.map((item, indx) => (
                            <tr  key={item.decay_net_weight || indx}>
                  
                              <td className="p-3">{item.decay_net_weight}KG</td>
                            </tr>
                          ))}
                          
                          </tbody>
                      
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DecayStockFollowUpsView;
